<template>
	<div ref="collapse">
		<slot name="title" />
		<div ref="content" class="collapse" :class="{ open }">
			<div ref="heightReference">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'b-collapse',
	props: {
		startOpen: Boolean
	},
	data() {
		return {
			realHeight: 0,
			open: this.startOpen,
			isAnimating: false,
			closeTimeout: null
		};
	},
	methods: {
		collapse() {
			this.$refs.content.style.height = '0px';
			this.open = false;
			this.isAnimating = true;
			this.$refs.content.style.overflow = 'hidden';
			this.closeTimeout = setTimeout(() => {
				this.isAnimating = false;
				this.$refs.heightReference.style.display = 'none';
			}, 250);
			this.$emit('collapse');
		},
		expand() {
			if (this.closeTimeout) window.clearTimeout(this.closeTimeout);
			this.$refs.content.style.height = this.$refs.content.scrollHeight + 'px';
			this.open = true;
			this.isAnimating = true;
			this.$refs.content.style.overflow = 'hidden';
			this.$refs.heightReference.style.display = 'block';
			setTimeout(() => {
				this.isAnimating = false;
				this.$refs.content.style.overflow = 'visible';
			}, 250);
			this.$emit('expand');
		},
		toggle() {
			if (this.open) this.collapse();
			else this.expand();
		}
	},
	mounted() {
		if (this.open) this.$refs.content.style.height = this.$refs.content.scrollHeight + 'px';
		else this.$refs.content.style.height = '0px';
	},
	updated() {
		if (this.open) {
			var contentHeight = this.$refs.heightReference.scrollHeight;
			if (contentHeight + 'px' != this.$refs.content.style.height) {
				this.$refs.content.style.height = contentHeight + 'px';
				if (!this.isAnimating) {
					this.$refs.content.style.overflow = 'hidden';
					setTimeout(() => {
						this.$refs.content.style.overflow = 'visible';
					}, 250);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.collapse {
	transition: height 0.25s;
	overflow: hidden;
	&.open {
		overflow: visible;
	}
}
</style>

<docs>
    Componente de collapse que funciona como um wrapper.

    ```js
    <BCollapse ref="collapse">
        <BButton slot="title" @click.native="$refs.collapse.toggle();">Clique aqui</BButton>
        <div>
            Collapse!
        </div>
    </BCollapse>
    ```
</docs>
